module.exports = __webpack_public_path__ + "static/img/not_found.fa1caaee.png";